import EventEmitter from './EventEmitter.js'

export default class Sizes extends EventEmitter
{
    constructor()
    {
      super()
      this.width = window.innerWidth
      this.height = window.innerWidth * (9/16)
      this.pixelRatio = 1

      if(window.innerHeight < window.innerWidth * (9/16)){
          this.height = window.innerHeight
          this.width = window.innerHeight * (16/9)
      }

      // Resize event
      window.addEventListener('resize', () =>
      {
          this.pixelRatio = 1

          this.width = window.innerWidth
          this.height = window.innerWidth * (9/16)
      
          if(window.innerHeight < window.innerWidth * (9/16)){
              this.height = window.innerHeight
              this.width = window.innerHeight * (16/9)
          }

          this.trigger('resize')
      })
    }
}